var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38795 0H0.415527L7.43928 18H10.3696L10.3248 11.6886L6.38795 0Z",
    fill: "#2891B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2616 0L10.3247 11.6886L10.3694 18H12.9642L17.8406 5.46021L14.4182 0H14.2616Z",
    fill: "#143A52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5697 0H19.9881H14.4183L17.8407 5.46021L19.9657 8.82353L14.1499 18H20.0328L22.8513 12.7889L23.3434 4.73356L20.5697 0Z",
    fill: "#7EDBFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.184 8.71972L31.7314 0H25.8708L23.3432 4.73356L22.8511 12.7889L25.8261 18H31.9998L26.184 8.71972Z",
    fill: "#4EBCEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVxLogo);
export default __webpack_public_path__ + "static/media/vx-logo.886e0844248675e54101865ee705a70f.svg";
export { ForwardRef as ReactComponent };